import NotificationsGroup from './NotificationsGroup';

export default NotificationsGroup;
